<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="名称">
        <el-input
          v-model="formLabelAlign.name"
          style="width: 500px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="cps">
        <el-tag
          style="margin-right: 10px;"
          v-if="formLabelAlign.cps_id!=''"
        >{{ cps_name }}</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="chooosecps"
        >选择cps</el-button>
      </el-form-item>
      <el-form-item
        label="选择游戏"
        prop="app_ids"
      >
        <el-button
          style="margin-right:10px"
          type="primary"
          size="mini"
          @click="choosegame"
        >选择游戏</el-button>
        <span>
          <el-tag
            v-for="item,index in gamearr"
            :key="index"
            closable
            style="margin-right:10px"
            @close="handleClosegame(item,index)"
          >{{ item.name }}</el-tag>
        </span>
      </el-form-item>
      <el-form-item
        v-if="type!=2"
        label="选择小程序"
        prop="app_ids"
      >
        <!-- <el-button size="mini" type="primary">选择</el-button> -->
        <el-button
          style="margin-right:10px"
          type="primary"
          size="mini"
          @click="chooseidsr"
        >选择小程序</el-button>
        <span>
          <el-tag
            v-for="item,index in wechatarr"
            :key="index"
            closable
            style="margin-right:10px"
            @close="handleClose(item,index)"
          >{{ item.account_name }}</el-tag>
        </span>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
    <el-dialog
      title="选择cps"
      :visible.sync="dialogVisiblecps"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <cpsdialog
        ref="cpsdialogview"
        @callbackcps="callbackcps"
      />
    </el-dialog>
    <el-dialog
      title="选择小游戏"
      :visible.sync="dialogVisiblegame"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <gamedialog
        ref="gamedialogview"
        @bandarrgame="bandarrgame"
      />
    </el-dialog>
  </div>
</template>

<script>
import { gameListstore, gameListupdate } from '@/api/sourceminiprogram.js'
import bandstaff from './bandstaff.vue'
import cpsdialog from './cpsdialog.vue'
import gamedialog from './gamedialog.vue'
export default {
  components: { bandstaff, cpsdialog, gamedialog },
  data() {
    return {
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        cps_id: ''
      },
      type: null,
      id: '',
      wechatarr: [],
      app_ids: [],
      dialogVisibler: false,
      cps_name: '',
      dialogVisiblecps: false,
      gamearr: [],
      dialogVisiblegame: false,
      game_ids: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    sumbit() {
      if (this.formLabelAlign.name === '') {
        this.$message.error('请输入名称')
        return
      }
      if (this.formLabelAlign.cps_id === '') {
        this.$message.error('请选择cps配置')
        return
      }
      if (this.gamearr.length == 0) {
        this.$message.error('请选择游戏')
        return
      }
      if (this.type != 2) {
        if (this.wechatarr.length == 0) {
          this.$message.error('请选择小程序')
          return
        }
      }
      this.app_ids = []
      this.app_ids = this.wechatarr.map(v => v.app_id)
      this.game_ids = []
      this.game_ids = this.gamearr.map(v => v.id)
      if (this.type === 1) {
        gameListstore({
          name: this.formLabelAlign.name,
          cps_id: this.formLabelAlign.cps_id,
          app_ids: this.app_ids,
          game_ids: this.game_ids
        }).then(res => {
          this.$message({
            message: '新增成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      } else {
        gameListupdate({ name: this.formLabelAlign.name, cps_id: this.formLabelAlign.cps_id, game_ids: this.game_ids, id: this.id }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$emit('updata')
        })
      }
    },
    send(type, item) {
      this.type = type
      if (this.type === 2) {
        this.formLabelAlign.cps_id = item.cps_id
        this.formLabelAlign.name = item.name
        this.cps_name = item.cps_path
        this.gamearr = item.game_names
        this.id = item.id
      }
    },
    handleClose(item, index) {
      this.wechatarr.splice(index, 1)
    },
    chooseidsr() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.wechatarr)
      })
    },
    async bandarr(arrs) {
      this.wechatarr = arrs
      this.dialogVisibler = false
    },
    chooosecps() {
      this.dialogVisiblecps = true
      this.$nextTick(() => {
        this.$refs.cpsdialogview.send()
      })
    },
    callbackcps(item) {
      console.log(item)
      this.dialogVisiblecps = false
      this.formLabelAlign.cps_id = item.id
      this.cps_name = item.path
    },
    choosegame() {
      this.dialogVisiblegame = true
      this.$nextTick(() => {
        this.$refs.gamedialogview.sendr(this.gamearr)
      })
    },
    handleClosegame(item, index) {
      this.gamearr.splice(index, 1)
    },
    bandarrgame(arr) {
      this.dialogVisiblegame = false
      this.gamearr = arr
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
